// Role helpers based on the user saved in localStorage "userData" at login.
// These only show/hide things on screen; the backend does the real check.

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('userData') || '{}') || {};
  } catch {
    return {};
  }
};

// Super admin = ADMIN with isSuperAdmin: true (sent by the login API).
export const isSuperAdminUser = () => {
  const user = getStoredUser();
  return user?.role === 'ADMIN' && user?.isSuperAdmin === true;
};
